import { render, staticRenderFns } from "./CommunityHappinessOperationRankingCommunityElderNumber.vue?vue&type=template&id=2079836f&scoped=true&"
import script from "./CommunityHappinessOperationRankingCommunityElderNumber.vue?vue&type=script&lang=js&"
export * from "./CommunityHappinessOperationRankingCommunityElderNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079836f",
  null
  
)

export default component.exports